import React, {ReactElement} from 'react';
import icon from '@assets/images/medops/logo.png';
import whiteLogoIcon from '@assets/images/medops/logo_white.png';

const MedopsLogo = (props: any): ReactElement => {
  const {color, ...rest} = props;
  if (color === 'white') {
    return <img alt={'app-logo'} src={whiteLogoIcon} {...rest} />;
  } else {
    return <img alt={'app-logo'} src={icon} {...rest} />;
  }
};

export default MedopsLogo;